import { makeObservable } from "mobx";
import { BaseSyncModelStore } from "@/store/sync/BaseSyncModelStore";
import { SyncModelKind } from "@/store/sync/types";
import { AppSubStoreArgs } from "@/store/types";
import { SpaceAccountCalendarModelData } from "@/store/calendar/space-account-calendar/types";
import { SpaceAccountCalendarObservable } from "@/store/calendar/space-account-calendar/SpaceAccountCalendarObservable";
import { SyncUpdateValue } from "@/store/sync/types";

export class AppStoreSpaceAccountCalendarStore extends BaseSyncModelStore<
  SpaceAccountCalendarObservable,
  SpaceAccountCalendarModelData
> {
  constructor(injectedDeps: AppSubStoreArgs) {
    super({ modelKind: SyncModelKind.SpaceAccountCalendar, ...injectedDeps });
    makeObservable(this, {
      createSyncModel: false,
    });
  }

  createSyncModel(
    data: SyncUpdateValue<SpaceAccountCalendarModelData>
  ): SpaceAccountCalendarObservable {
    return new SpaceAccountCalendarObservable({
      id: data.model_id,
      data,
      store: this.store,
    });
  }
}
